import React from 'react';
import PropTypes from 'prop-types';

const Phase1ResidenceRules = ({
  signatureData,
  staffSignatureData,
  currentDate,
}) => {

  // Rules data
  const generalRules = [
    "Client will always respect staff and other clients.",
    "Client may not discharge against medical advice without approval from the Clinical Director. Failure to do so will forfeit property that is being held by the center until the centers normal business hours of Monday through Friday between 9:00 a.m. and 5:00 p.m.",
    "Clients are not permitted to have the following while at Phase 1 property: wallets, money, cell phones, or any electronic devices.",
    "Clients are subject to random urinalysis/breathalyzers.",
    "Clients may not talk negatively about staff or other clients. Excessive negative talk and or negative morale for example: wanting to leave the program and or house, will lead to Client being placed on a behavioral plan or even removal from the property. Issues and concerns can be addressed during the weekly house meeting.",
    "All common and private areas and clients' possessions are subject to random searches.",
    "Clients will not be allowed to make any phone calls for three days, except for an initial call to state the client arrived on the property safety.",
    "Clients will be allowed to have 20 minutes of phone time daily after the blackout period. A call list must be provided and approved upon introduction to house. Later changes in phone list must be approved by the client care and housing manager.",
    "Client funds can only be setup via online or through the office manager. When Client completes the program or leaves the program these funds will be REFUNDED ONLY to the credit card that they originated from. These funds will NOT be cashed out.",
    "Clients will attend the mandatory weekly house meeting.",
    "Clients will attend five to seven 12 Step meetings per week, which includes 12 Step meetings held on property. Clients will receive a meeting sheet that must be signed by a chairperson during each off-property meeting. Transportation will be provided by staff.",
    "Clients will attain a sponsor within the first two weeks.",
    "Clients' sponsors and sober supports are allowed on property with prior approval.",
    "Clients will be given the opportunity to attend the outside gym or the gym in the garage with staff supervision. Participation is encouraged but not mandatory.",
    "Clients are to be fully clothed in all common areas (shorts and shirts).",
    "Client will maintain personal hygiene, washing of clothes, and general tidiness.",
    "In addition to keeping personal areas clean, each client will be assigned a weekly house chore. Cleaning inspections will take place randomly and periodically.",
    "Clients must be in their bedrooms by 11:00 PM Sunday through Thursday and by 12:00 AM Friday and Saturday.",
    "No loud music is permitted.",
    "No sleeping on couches.",
    "Clients are not permitted in anyone else's room without permission.",
    "No eating or drinking of others' food.",
    "No lending or borrowing of personal items.",
    "No tobacco or e-cigarette product use inside the residence.",
    "If clients receive mail or packages, it will be searched by staff.",
    "Bottled water only permitted inside program transportation, no other food and drink permitted.",
    "Legacy Healing Center reserves the right to hold on to client's property in the event that an impulsive or irrational decision to leave treatment against medical or clinical advice is made prior to speaking with clinical, medical and case management.",
    "FaceTime is NOT permitted in common areas under any circumstances.",
    "FaceTime is ONLY permitted if you are given special approval and is ONLY allowed in approved predesignated areas."
  ];

  const absoluteRules = [
    "Absolutely no drug or alcohol use, and no drugs or alcohol on property.",
    "No sharing/abusing prescribed or over-the-counter medications.",
    "No medications or supplements of any kind on your person. Medications will be collected, counted, documented, held in the house safe, and distributed by the staff for the entire time the client is living at the residence.",
    "No substances containing alcohol (including mouthwash and hand sanitizer) or fermented beverages of any kind; and no pre-workout supplements, fat burners, prohormones, steroids or kava are allowed on property.",
    "No acts or threats of violence.",
    "No bullying, intimidation, verbal abuse, or emotional abuse.",
    "No weapons.",
    "No stealing.",
    "No gambling.",
    "No women allowed on property without prior approval at any time.",
    "No sexual activity.",
    "No pornographic materials.",
    "No destruction of property. Client will be billed for damages incurred.",
    "No racism, sexism, ableism, religious, spiritual, and/or any other discrimination."
  ];

  return (
    <div
      style={{
        fontFamily: "Arial",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.2",
        height: "2400px",
        fontSize: "18px"
      }}
    >
      {/* Title */}
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h2 style={{
          fontFamily: 'Arial',
          fontSize: '14pt',
          fontWeight: 'bold',
          paddingBottom: '5px',
          borderBottom: '2px solid black',
          display: 'inline-block'
        }}>
   Phase 1 Residence Rules
        </h2>
      </div>
      
      

      {/* Introduction */}
      <p style={{ marginBottom: '50px', fontWeight:'bold', textAlign:'center'}}>
        Clients must always follow rules and regulations. Failure to comply will include consequences up to and including dismissal from recovery residence.
      </p>

      {/* General Residence Rules */}
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{
          fontSize: '12pt',
         
          marginBottom: '10px',
          textDecoration: 'underline'
        }}>
          General Residence Rules
        </h2>
        <ol style={{
          paddingLeft: '20px',
          listStyleType: 'none',
          counterReset: 'rule-counter'
        }}>
          {generalRules.map((rule, index) => (
            <li key={`general-${index}`} style={{
              marginBottom: '10px',
              counterIncrement: 'rule-counter',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: '-20px',
                fontWeight: 'bold'
              }}>
                {index + 1}.
              </span>
              <span style={{ marginLeft: '10px' }}>{rule}</span>
            </li>
          ))}
        </ol>
      </section>

      {/* Absolute Residence Rules */}
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{
          fontSize: '14pt',
          
          marginBottom: '10px',
          textAlign:'center'
        }}>
          Absolute Residence Rules 
        </h2>
        <h2 style={{
          fontSize: '14pt',
          fontWeight: 'bold',
          marginBottom: '10px',
          textAlign:'center'
        }}>
           No infractions allowed
        </h2>
        <ol style={{
          paddingLeft: '20px',
          listStyleType: 'none',
          counterReset: 'absolute-counter'
        }}>
          {absoluteRules.map((rule, index) => (
            <li key={`absolute-${index}`} style={{
              marginBottom: '10px',
              counterIncrement: 'absolute-counter',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: '-20px',
                fontWeight: 'bold'
              }}>
                {index + 1}.
              </span>
              <span style={{ marginLeft: '10px' }}>{rule}</span>
            </li>
          ))}
        </ol>
      </section>

      {/* Signature Section */}
      <div
        style={{
          marginTop: "30px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "30px" }}>
            <img
              src={signatureData || ""}
              alt="Client Signature"
              style={{
                width: "200px",
                height: "70px",
                borderBottom: "1px solid black",
              }}
            />
            <p>
              <span>Client Signature:</span>
            </p>
          </div>
        </div>
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "20px", marginTop: signatureData ? "60px" : "0", }}>
            {/* {!currentDate && ( */}
            <div>{currentDate}</div>
            <div
              style={{
                borderBottom: "1px solid black",
                width: "300px",
                // height: "30px",
              }}
            ></div>
            {/* )} */}
            <p>Date:</p>
          </div>
        </div>
      </div>
    </div>
  );
};

Phase1ResidenceRules.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }).isRequired
};

export default Phase1ResidenceRules;